// src/main.ts
import { createApp } from 'vue'
import App from './App.vue'
import router from './router' // Import the router

// 1. Import Vuestic UI and its global config type
import { createVuestic } from 'vuestic-ui'
import 'vuestic-ui/css'

// 2. Define your custom theme configuration
const customVuesticConfig = {
  fonts: {
    googleFonts: false,
  },
  components: {
    all: {
      fontFamily: '"Inter", sans-serif',
    },
  },
}

// 4. Import your local font definitions (assuming you are using the src/assets method)
// If you defined fonts in index.html, this line is not strictly needed, but it's best practice.
//import "./assets/fonts.css";

const app = createApp(App)

app.use(router) // Use the router

// 5. Register Vuestic UI with your custom configuration
app.use(createVuestic({ config: customVuesticConfig }))

app.mount('#app')
